module.exports = __webpack_public_path__ + "static/img/ai-video-homepage.5be8d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/ai-video-homepage.png
// module id = F+o6
// module chunks = 1